<template>

    <bottom-sheet ref="bottomsheet">

        <div class="bsac">

            <p class="text-xlSemibold">{{$t('advanced_connection_email_not_recognized')}}</p>

            <p class="mt__8 mtd__24 text-baseRegular color__moon">{{$t('login_imap_manual_desc')}}</p>

            <p class="mt__8 text-baseRegular">{{$t('advanced_connection_find_info')}}</p>

            <button class="mt__16 mtd__32 cta-fluid-secondary" @click="goToAdvancedConnection">{{$t('advanced_connection')}}</button>

            <button class="mt__8 cta-medium-tertiary" @click="close">{{$t('settings_cta_cancel_delete')}}</button>

        </div>

    </bottom-sheet>

</template>

<script>
import BottomSheet from '../../components/bottomSheet/BottomSheet'
import SessionStorage from '../../helpers/sessionStorage'

export default {

    name: 'bottom-sheet-advanced-connection',

    components: {BottomSheet},

    data () {
        return {
            email: ''
        }
    },

    methods: {

        open(email) {
            this.email = email
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        goToAdvancedConnection() {
            SessionStorage.setItem(SessionStorage.KEYS.EMAIL, this.email)
            this.routerPush('/login/advanced-connection')
        }
    }

}

</script>

<style lang="scss" scoped>

.bsac {
    padding: 0 16px 16px;
    @media screen and (min-width: $above-tablet-length) {
        padding: 32px;
    }
}

</style>
